import { render, staticRenderFns } from "./AddAppointment.vue?vue&type=template&id=2f27498e&"
import script from "./AddAppointment.vue?vue&type=script&lang=js&"
export * from "./AddAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports